import { t } from 'i18next';

export const dashboardElectionWiseCsvColumn = [
  {
    id: 1,
    key: 'settings_name',
    name: t('DASHBOARD.UPAZILA'),
  },
  {
    id: 2,
    key: 'total_voters',
    name: t('DASHBOARD.TOTAL_VOTE'),
  },
  {
    id: 3,
    key: 'total_center',
    name: t('DASHBOARD.TOTAL_CENTER'),
  },
  {
    id: 4,
    key: 'total_casted_vote',
    name: t('DASHBOARD.VOTE_RECEIVED'),
  },
  {
    id: 5,
    key: 'percentage',
    name: t('DASHBOARD.PERCENTAGE'),
  },
];

export const countryReportCsvColumn = [
  {
    id: 1,
    key: 'total_voters',
    name: t('DASHBOARD.TOTAL_VOTE'),
  },
  {
    id: 2,
    key: 'total_center',
    name: t('DASHBOARD.TOTAL_CENTER'),
  },
  {
    id: 3,
    key: 'total_casted_vote',
    name: t('DASHBOARD.VOTE_RECEIVED'),
  },
  {
    id: 4,
    key: 'percentage',
    name: t('DASHBOARD.PERCENTAGE'),
  },
  {
    id: 5,
    key: 'time_range',
    name: t('DASHBOARD.PERCENTAGE'),
  },
];
